import { axios } from "utilities/axios";
import { useFlags } from "hooks-for/feature-flags";
import { FEATURE_FLAGS } from "types-for/feature-flags";
import { useLayoutEffect } from "react";

/**
 * Clickhouse Axios Interceptor
 * @returns null
 */
export const ClickhouseAxiosInterceptor = () => {
    const flags = useFlags([FEATURE_FLAGS.Clickhouse]);
    useLayoutEffect(() => {
        const interceptorId = axios.interceptors.request.use((request) => {
            if (flags[FEATURE_FLAGS.Clickhouse].enabled) {
                request.headers["X-Use-ClickHouse"] = true;
            }
            return request;
        });
        return () => {
            axios.interceptors.request.eject(interceptorId);
        };
    }, [flags]);

    return null;
};
